import {Component} from 'react';
import {connect} from 'react-redux';

class Logout extends Component {

  componentDidMount() {
    this.props.logout();
  }

  render() {
    return null;
  }
}

const mapDispatchToProps = dispatch => ({
  logout: (payload) => dispatch({type: 'LOGOUT.REQUEST', payload}),
})

const mapStateToProps = state => ({
  authentication: state.authentication,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Logout)



// WEBPACK FOOTER //
// ./src/components/logout/Logout.js